export default class CursorEffectService {
    constructor() {
        if ($('[data-id="iris-cursor"]').length > 0) {
            import("@scripts/actions/cursor-effect.action" /* webpackChunkName: "scripts/cursor-effect.action" */).then(
                ({default: CursorEffectAction}) => {
                    new CursorEffectAction()
                }
            )
        }
    }
}
